export default "__VITE_ASSET__x3I88Gnt__"